import { useCallback, useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { KnowledgeTrailDetail } from '../../features/knowledge-trail/components/KnowledgeTrailDetail/KnowledgeTrailDetail';
import { getKnowledgeTrails } from '../../features/knowledge-trail/api';
import { IKnowledgeTrail } from '../../features/knowledge-trail/types';
import { useAuth } from '../../hooks/useAuth';
import { Loading } from '../../components/Loading';

export function KnowledgeTrail() {
  const { trailId } = useParams<{ trailId: string }>();
  const { client, player } = useAuth();
  const location = useLocation();
  const stateTrail = (location.state as { trail: IKnowledgeTrail })?.trail;
  const [trail, setTrail] = useState<IKnowledgeTrail | null>(stateTrail);

  const fetchTrail = useCallback(async () => {
    if (!client?.id || !player?.id) return;
    try {
      const trails = await getKnowledgeTrails(client.id, player.id);
      const found = trails.find((t) => t.id === trailId);
      if (found) setTrail(found);
    } catch (error) {
      console.error('Error fetching knowledge trail:', error);
    }
  }, [trailId, client?.id, player?.id]);

  useEffect(() => {
    fetchTrail();
  }, [fetchTrail]);

  if (!trail) {
    return <Loading />;
  }

  return <KnowledgeTrailDetail trail={trail} onRefresh={fetchTrail} />;
}
